import { Card, CardActionArea, CardContent } from "@material-ui/core";
import { CSSProperties, ReactElement } from "react";
import styles from "./RxProductContainer.module.css";

interface RxProductContainerProps {
	style?: CSSProperties;
	className?: string;
	children: ReactElement;
	onClick?: () => void;
}

const RxProductContainer = (props: RxProductContainerProps) => {
	return (
		<Card
			className={props.className ?? styles.defaultPaper}
			style={props.style}
		>
			{props.onClick ? (
				<CardActionArea
					className={styles.fullHeight}
					onClick={props.onClick}
				>
					<CardContent className={styles.fullHeight}>
						{props.children}
					</CardContent>
				</CardActionArea>
			) : (
				<>
					<CardContent className={styles.fullHeight}>
						{props.children}
					</CardContent>
				</>
			)}
		</Card>
	);
};

export default RxProductContainer;
